import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKindResultDecision } from '../interfaces/IKindResultDecision';

export async function fetchKindResultDecisionCatalog(): Promise<IKindResultDecision[]> {
  return apiGet<IKindResultDecision[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/kind-result-decision`,
  );
}
